module.exports = __webpack_public_path__ + "img/Work-Anniversary.e5103577.png";